module.exports = __webpack_public_path__ + "eb9e62f3915f69bc5f89de04177ab4eb.fbx";